import script from "./UsuarioDarBajaPublicidad.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioDarBajaPublicidad.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioDarBajaPublicidad.vue?vue&type=style&index=0&id=562febda&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562febda"]])

export default __exports__